export default "/assets/images/dusty-taupe-sm.64ac897bf21b0fc8.webp";